import { render, staticRenderFns } from "./finally.vue?vue&type=template&id=bd4bbf22&scoped=true&"
import script from "./finally.vue?vue&type=script&lang=js&"
export * from "./finally.vue?vue&type=script&lang=js&"
import style0 from "./finally.vue?vue&type=style&index=0&id=bd4bbf22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4bbf22",
  null
  
)

export default component.exports